
import { Api } from '@/api';
import GlobalLatestPostsCard from '@/components/social/GlobalLatestPostsCard.vue';
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { Bot } from 'ignite360-core';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'feed',
  components: { GlobalLatestPostsCard },
})
export default class Feed extends Vue {
  isLoading = true;

  get bots(): Bot[] {
    return this.$store.state.bots.bots;
  }

  async created() {
    Api.setAuthorization(this.$store.state.auth.authorization);
    this.isLoading = true;
    try {
      await this.$store.dispatch('bots/fetchAll');
    } catch (e) {
      this.$notify.error({
        title: 'Loading projects failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isLoading = false;
    }
  }
}
